import { MAX_PAYMENT } from '~/src/constants';
import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';
import { EValidityStatus } from '~/src/features/payments-abn/store/actionCreators';
import { TState } from '~/src/store';

const isAbnProgramTermsEnabled = getIsAbnLoyaltyProgramEnabled();

/**
 * Проверяет возможность совершения платежа
 */
export const selectIsPaymentValid = (state: TState): boolean  => {
    const { paymentSum, isUseBonuses, bonusesValue, isConnectAutoPay, paymentSumValidity } = state.payment.paymentData;
    const loyalty = state.loyalty;
    const { info: { bonuses } } = loyalty;

    const requiredBonusesToPay = isAbnProgramTermsEnabled
        ? paymentSum / 0.2
        : paymentSum;

    return isConnectAutoPay
        ? (paymentSum >= 0 &&
            paymentSum <= (isUseBonuses ? MAX_PAYMENT + Math.min(bonusesValue, bonuses) : MAX_PAYMENT) &&
            bonusesValue <= Math.min(bonuses, requiredBonusesToPay))
        : paymentSumValidity.isValid === EValidityStatus.IS_VALID && !!paymentSum && bonusesValue <= bonuses && bonusesValue <= requiredBonusesToPay;
};
